import { useEffect, useState } from 'react';
import { defaultRoutePath } from './paths.js';

export function normalizePath(path: string): string {
  if (path === '/') {
    return defaultRoutePath;
  }

  if (path.length > 1 && path.endsWith('/')) {
    return path.slice(0, -1);
  }

  return path;
}

export function currentVisiblePath(): string {
  return normalizePath(window.location.pathname);
}

export function pushPath(path: string): void {
  window.history.pushState({}, '', path);
}

/** Used for gating redirects: a push would trap the Back button in a redirect loop. */
export function replacePath(path: string): void {
  window.history.replaceState({}, '', path);
}

export function useVisiblePath() {
  const [visiblePath, setVisiblePath] = useState(currentVisiblePath);

  useEffect(() => {
    function handlePopState() {
      setVisiblePath(currentVisiblePath());
    }

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return { visiblePath, setVisiblePath };
}
